import { useRef, useCallback } from 'react';

/**
 * Hook dostarczający referencję SVG i konwersję współrzędnych myszy na współrzędne SVG.
 * Czyta viewBox bezpośrednio z DOM — działa niezależnie od zoom/pan ustawionych
 * przez wrapper (manipulacja viewBox).
 */
export function useSvgCoordinates() {
  const svgRef = useRef(null);

  const getSvgCoordinates = useCallback((e) => {
    const svg = svgRef.current;
    if (!svg) return { x: 0, y: 0 };

    const rect = svg.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    // Czytaj aktualny viewBox z atrybutu (ustawiany przez React jako string).
    // Format: "x y width height". Gdy brak — fallback do rect (1:1 pixel = svg).
    const vbAttr = svg.getAttribute('viewBox');
    if (vbAttr) {
      const parts = vbAttr.trim().split(/\s+/).map(Number);
      if (parts.length === 4 && parts.every(n => !isNaN(n)) && rect.width > 0 && rect.height > 0) {
        const [vbX, vbY, vbW, vbH] = parts;
        const sx = vbW / rect.width;
        const sy = vbH / rect.height;
        return {
          x: (clientX - rect.left) * sx + vbX,
          y: (clientY - rect.top) * sy + vbY,
        };
      }
    }

    return {
      x: clientX - rect.left,
      y: clientY - rect.top,
    };
  }, []);

  return { svgRef, getSvgCoordinates };
}
